/* ============================================================
   BROKEN HEARTS — IL RESPONSO
   Sette schermate dentro un palco fisso, una pescata cieca, e tre pezzi
   raccontati uno alla volta.

   Questo file NON contiene un motore. La scelta dei tre pezzi resta
   pickRelics di bh-rite.js, raggiunto via window.BHRiteEngine: due motori
   che divergono al primo fix sarebbero il vero errore. Qui c'e' solo:
   la navigazione fra schermate, lo stato delle tre porte, la mappatura verso
   l'oggetto risposte che il motore gia' si aspetta, il MAZZO DA CUI PESCARE
   (che e' una scelta del Responso, non del motore) e il rendering.

   La mappatura, per intero:
     porta I  dove lo porti      -> vis  (statement | intimate)  filtra il mazzo
     porta II cosa resta in vista-> stone ('blank' = la frattura resta aperta)
     porta III a cosa serve      -> grappolo di temi (ricordare | andare oltre)
     la riga scritta             -> readThought(): affina il tema dentro il
                                    grappolo, puo' nominare la pietra, e
                                    restituisce LA PAROLA VERA da citare.

   COSA E' CAMBIATO IL 29-08-2026 (secondo giro, richieste owner)
   1. Una via d'uscita, dalla prima schermata e su tutte, che risponde a ESC.
   2. I tre pezzi non compaiono piu' in blocco: schermata loro, uno alla volta.
   3. Via il "rifai la veglia": si fa una volta, e si torna alla collezione.
   4. Dopo la carta non si scorre: la lettura e' una schermata nuova.
   5. La storia del pezzo arriva dal metafield card_subtitle_<locale>, gia'
      tradotto, e non piu' dal `why` inglese del motore.
   6. Solo argento, e la coerenza col tema decisa qui. Vedi §IL MAZZO.

   COSA E' CAMBIATO IL 02-09-2026 (terzo giro, cinque richieste owner)
   A. Un bottone solo sulla riga scritta, con l'etichetta che segue il campo.
   B. LA PESCATA E' DIVENTATA UNA SCELTA. Vedi §IL MAZZO E LA PIETRA.
   C. I tre pezzi si raccontano a tre battute dentro il pannello, e il prezzo
      arriva per ultimo.
   D. Fuori collane e bracciali: il mazzo tiene anelli, pendenti, orecchini.
   E. Il rito si fa una volta: la propria lettura resta nel browser e tornando
      qui si riatterra su quella. Vedi §UNA VOLTA SOLA (e il suo limite).

   §IL MAZZO E LA PIETRA. Fino al 02-09-2026 la pietra era decisa da
   buildAnswers PRIMA che il mazzo comparisse, e la porta II la decideva quasi
   da sola: `if (d2 === 'fracture') stone = 'blank'`, cioe' meta' delle persone
   vedeva sempre NIHIL. Le tre carte coperte erano quindi una scenografia.
   Adesso le carte sono SETTE, una per pietra, mescolate a ogni caricamento, e
   la carta che si gira DECIDE la pietra: non esiste piu' nessuna pietra
   precalcolata. L'assegnazione posizione -> pietra vive in una variabile
   chiusa in questa IIFE (stonesInDeck): non e' un attributo, non e' una
   classe, non e' una proprieta' sull'elemento, quindi non e' leggibile ne'
   dal sorgente servito ne' dalla console.

   §E ALLORA LA PORTA II? Conserva due conseguenze vere, e sono le stesse che
   aveva gia': (1) entra in THEME_BY_DOORS insieme alle altre due porte, dove
   seen/kept per fracture/bond danno otto combinazioni e sette temi possibili,
   e il tema decide il pezzo di testa; (2) resta nel token `v` del link
   condiviso, quindi chi riapre la lettura riceve lo stesso oggetto risposte.
   Cio' che NON fa piu' e' decidere la carta al posto di chi la gira.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-bhv]');
  if (!root) return;

  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* owner 29-08-2026: qui stava l'indirizzo del film del cuore che si spezza.
     Ne sono stati bocciati due, quello disegnato e quello del Rito. La rottura
     adesso si dice, non si illustra. Se un giorno tornasse, il film del Rito e'
     in assets/bh-rite.js sotto HEART_FILM. */

  /* ---------- copy localizzata ---------- */
  function readJSON(sel) {
    var tag = document.querySelector(sel);
    if (!tag) return {};
    try { return JSON.parse(tag.textContent); } catch (e) { return {}; }
  }
  /* il filtro | t di Shopify escapa gia' l'HTML: l'apostrofo arriva come
     &#39;. Va sciolto prima di finire in textContent, o in pagina si legge
     l'entita' nuda (trappola nota, CLAUDE.md). */
  var _dec = document.createElement('textarea');
  function deEnt(s) {
    if (typeof s !== 'string' || s.indexOf('&') < 0) return s;
    _dec.innerHTML = s;
    return _dec.value;
  }
  var C = readJSON('[data-bhv-i18n]');
  for (var ck in C) if (typeof C[ck] === 'string') C[ck] = deEnt(C[ck]);

  var STONES = readJSON('[data-bhv-stones]');
  for (var sk in STONES) {
    if (!STONES[sk]) continue;
    STONES[sk].draw = deEnt(STONES[sk].draw || '');
    STONES[sk].reading = deEnt(STONES[sk].reading || '');
    STONES[sk].why = deEnt(STONES[sk].why || '');
  }

  /* La mappa handle -> sottotitolo, costruita in Liquid dalla sezione dai
     metafield custom.card_subtitle_<locale>. products.json, da cui il motore
     costruisce il catalogo, non porta i metafield: senza questa mappa la
     storia del pezzo resterebbe l'inglese di FAMILY_META.why su quindici
     lingue. Se un handle non c'e' (il tetto di 250 di paginate, o un pezzo
     senza sottotitolo) si ricade sul motore, che e' esattamente cio' che
     succedeva prima: non si perde niente. */
  var SUBS = readJSON('[data-bhv-subs]');
  for (var uk in SUBS) if (typeof SUBS[uk] === 'string') SUBS[uk] = deEnt(SUBS[uk]);

  /* ---------- LE LETTURE DI POSIZIONE ----------
     Sette temi per tre posti nella stesa. Due sorgenti, e vanno tenute
     distinte perche' e' l'unica cosa che rende vero questo testo:
       la POSIZIONE viene dall'INDICE del pannello (0 held, 1 kept, 2 quiet);
       il TEMA viene DAL PEZZO (p.themes[0]), non dalla lettura.
     Misurato sul catalogo vivo: nel 46% delle letture almeno un pezzo NON ha
     il tema che la lettura ha scelto, perche' il motore il tema lo premia
     (+36 / +20) ma non lo filtra. Agganciare questo testo al tema della
     lettura vorrebbe dire raccontare, sotto quel pezzo, una cosa che quel
     pezzo non e'. Agganciandolo al tema del pezzo il testo regge sempre.
     Un tema che non e' fra i sette (in bh-rite.js almeno una famiglia porta
     `t: ['kluster-sanguinis']`) non trova la chiave, e allora non si mostra
     niente: meglio muti che con un testo a caso. */
  var POS = readJSON('[data-bhv-pos]');
  var POS_SLOT = ['held', 'kept', 'quiet'];
  for (var pk in POS) {
    if (!POS[pk]) continue;
    for (var si = 0; si < POS_SLOT.length; si++) {
      POS[pk][POS_SLOT[si]] = deEnt(POS[pk][POS_SLOT[si]] || '');
    }
  }

  /* ---------- stato ---------- */
  var S = {
    1: null, 2: null, 3: null,
    text: '',
    a: null,
    word: null,
    picks: [],
    drawn: null,    /* la carta girata (o true se la lettura arriva gia' fatta) */
    ready: false,   /* il motore ha risposto: la pietra e' decisa */
    shown: -1,      /* il pezzo che si sta guardando */
    seen: -1        /* il pezzo piu' avanti a cui si e' arrivati */
  };

  var CLUSTER = {
    remember: ['perdita', 'preghiera', 'segreto'],
    past: ['inizio', 'fuoco', 'taglio']
  };

  /* ---------- LE PORTE DECIDONO DAVVERO IL TEMA (29-08-2026) ----------
     Prima il tema usciva da hashStr(d1+d2+d3) % 3. E' deterministico, ma non
     e' una scelta: misurato sul catalogo vivo, delle otto combinazioni di
     porte ne uscivano solo tre temi su sette, e tutto il ramo "andare oltre"
     collassava su `inizio` in tutte e quattro le sue combinazioni, cioe' la
     porta III non aveva nessuna conseguenza su quel ramo. Un hash che sceglie
     per noi e' un dado, non una lettura.
     Qui la tabella e' esplicita, e ogni riga si legge:
       seen   = lo porti dove lo vedono tutti      kept  = dove lo sai solo tu
       fracture = la frattura resta aperta         bond  = c'e' cio che ha tenuto
     RICORDARE: la perdita mostrata (seen+fracture), la devozione portata in
     vista (seen+bond), la rottura tenuta nascosta (kept+segreto), e la perdita
     custodita (kept+bond).
     ANDARE OLTRE: il taglio dichiarato (seen+fracture), il ricominciare
     mostrato (seen+bond), cio che ha bruciato e resta privato (kept+fracture),
     il ricominciare tenuto per se' (kept+bond).
     La riga scritta, quando c'e', batte questa tabella: readThought sceglie
     dentro lo stesso grappolo. */
  var THEME_BY_DOORS = {
    remember: { seen_fracture: 'perdita', seen_bond: 'preghiera', kept_fracture: 'segreto', kept_bond: 'perdita' },
    past:     { seen_fracture: 'taglio',  seen_bond: 'inizio',    kept_fracture: 'fuoco',   kept_bond: 'inizio' }
  };

  var VALUES = {
    1: { seen: 'statement', kept: 'intimate' },
    2: { fracture: 1, bond: 1 },
    3: { remember: 1, past: 1 }
  };
  var LETTER = { seen: 'a', kept: 'b', fracture: 'a', bond: 'b', remember: 'a', past: 'b' };
  var UNLETTER = {
    1: { a: 'seen', b: 'kept' },
    2: { a: 'fracture', b: 'bond' },
    3: { a: 'remember', b: 'past' }
  };

  /* ---------- da dove sei entrato ----------
     La riga sulla pagina collezione passa ?c=<handle>. Vale la stessa regola
     del Rito: se hai DICHIARATO una categoria entrando da /collections/pendants,
     la forma e' sacra e la lettura non ti risponde con un anello. Le case
     (reminescenza, palinsesto, materia) restringono la collezione, non la forma.
     Se il parametro non c'e' o non lo riconosciamo, resta tutto aperto.
     `handle` tiene il valore ORIGINALE, non normalizzato: e' l'indirizzo a cui
     riporta la via d'uscita, e /collections/bh-rings non e' /collections/rings. */
  var SEED = { cat: 'any', collection: 'any', raw: '', handle: '' };
  /* e' una funzione e non piu' un blocco chiuso perche' la chiama anche il
     ritorno di chi il rito lo ha gia' fatto: la porta d'ingresso e' salvata
     insieme alla lettura, e senza questa riga la via d'uscita del ritorno
     porterebbe alla home invece che alla collezione da cui si era entrati. */
  /* `setHandle` a false applica SOLO la cella di lettura (cat, collection) e
     lascia stare `handle`. Serve al ritorno di chi il rito lo ha gia' fatto:
     vedi la nota estesa al richiamo, piu' sotto. Assente = true, cosi' il caso
     normale resta quello di prima. */
  function applySeed(orig, setHandle) {
    if (setHandle === undefined) { setHandle = true; }
    orig = String(orig || '').toLowerCase();
    if (!orig || !/^[a-z0-9-]{1,60}$/.test(orig)) return;
    if (setHandle) { SEED.handle = orig; }
    var c = orig.replace(/^bh-/, '');
    SEED.raw = c;
    /* NIENTE collane ne' bracciali (owner 02-09-2026): non sono piu' nel mazzo,
       quindi entrando da /collections/necklaces la forma non e' piu' sacra e
       resta 'any'. Tenerli qui vorrebbe dire dichiarare sacra una forma che il
       Responso non puo' piu' restituire, cioe' far allentare openCell a ogni
       lettura per niente. */
    var catMap = { rings: 'ring', pendants: 'cross', earrings: 'ear' };
    if (catMap[c]) SEED.cat = catMap[c];
    if (c === 'reminescenza' || c === 'reminiscenza') SEED.collection = 'rem';
    else if (c === 'palinsesto') SEED.collection = 'pal';
    else if (c === 'materia') SEED.collection = 'mat';
  }
  (function () {
    var p;
    try { p = new URLSearchParams(location.search); } catch (e) { return; }
    applySeed(p.get('c'));
  })();

  /* ---------- la via d'uscita ----------
     owner 29-08-2026: "dalla pagina il-responso non si puo' uscire". La pagina
     gira su un layout senza header, quindi non c'era proprio niente da
     toccare. Il segno di chiusura e' un link vero, gia' reso da Liquid con la
     home come indirizzo: qui viene riscritto sulla collezione d'ingresso
     quando c'e', e l'etichetta segue. Senza JavaScript resta la home, che e'
     comunque una via d'uscita. */
  function rootUrl() {
    try { if (window.BHRiteEngine && window.BHRiteEngine.root) return window.BHRiteEngine.root(); } catch (e) {}
    return '/';
  }
  function exitHref() {
    if (!SEED.handle) return rootUrl();
    return rootUrl() + 'collections/' + SEED.handle;
  }
  function exitLabel() {
    return SEED.handle ? (C.backCol || 'Back to the collection') : (C.backHome || 'Back to the shop');
  }
  function leave() { location.href = exitHref(); }

  /* Il dizionario del rito riconosce anche delle locuzioni ("non ho detto"),
     e in quel caso cita la prima parola della frase che compare davvero nel
     testo: puo' uscire «non». Nel Rito quella parola era un dettaglio; qui e'
     il centro della pagina, e un NON grande cosi' non e' una lettura, e' un
     refuso. Se la parola non regge da sola, il responso non cita niente:
     meglio muti che ridicoli. */
  var WEAK = ('non ho hai che chi cosa come dove quando piu meno molto tutto tutti nulla niente ' +
    'sono stato stata essere avere fare dire poi gia ancora sempre mai qui quello questa questo ' +
    'the and but not for was were have has had did does with from that this then just very much ' +
    'been being about into over under some what when where who why how').split(' ');
  function worthQuoting(w) {
    if (!w) return null;
    var n = String(w).trim();
    if (n.length < 4) return null;
    if (WEAK.indexOf(n.toLowerCase()) > -1) return null;
    return n;
  }

  /* ---------- una lettura arrivata da un link condiviso ----------
     Si legge SUBITO, prima di costruire qualunque cosa: se questa pagina e' la
     lettura di qualcun altro non c'e' nessuna carta da pescare e nessuna
     schermata d'ingresso da animare, si atterra direttamente sul responso.
     Tutto cio' che arriva dall'URL passa da una lista chiusa prima di essere
     usato, e la parola citata finisce solo in textContent. */
  var THEME_KEYS = ['perdita', 'taglio', 'peso', 'preghiera', 'fuoco', 'segreto', 'inizio'];
  var STONE_KEYS = ['garnet', 'emerald', 'spinel', 'diamond', 'sapphire', 'amethyst', 'blank'];

  /* Una lettura, da qualunque parte arrivi (URL o memoria del browser), passa
     di qui prima di essere usata: tre porte in [ab], un tema e una pietra da
     una lista chiusa, e la parola citata ripulita e mai messa in innerHTML.
     niente \p{L} con flag u: su un browser vecchio quella regex non fa fallire
     la riga, fa fallire il PARSE dell'intero file, e la pagina resta muta.
     Meglio un intervallo esplicito. */
  function sanitizeReading(v, t, s, w) {
    if (!v || !/^[ab]{3}$/.test(String(v))) return null;
    return {
      v: String(v),
      t: (t && THEME_KEYS.indexOf(t) > -1) ? t : null,
      s: (s && STONE_KEYS.indexOf(s) > -1) ? s : null,
      w: w ? worthQuoting(String(w).replace(/[^A-Za-z0-9À-ɏͰ-ϿЀ-ӿ぀-ヿ一-鿿가-힯'’-]/g, '').slice(0, 32)) : null
    };
  }

  /* ---------- UNA VOLTA SOLA (owner 02-09-2026) ----------
     "Il Quiz puo' essere fatto esclusivamente una volta per utente in tutto il
     sito. Una volta fatto scompare o viene lasciato qualche frase evocativa
     per farlo sembrare stra-figo come permanenza, rimasto."

     IL LIMITE, DICHIARATO E NON NASCOSTO: localStorage e' per BROWSER, non per
     persona. Chi cambia browser, chi passa dal telefono al portatile, chi
     naviga in incognito e chi cancella i dati del sito rifara' il rito, e non
     c'e' modo di impedirlo da qui. Per legarlo alla persona servirebbe un
     account cliente, e questa pagina non raccoglie nemmeno l'email per scelta
     dell'owner (28-08-2026). E' una decisione, non un difetto da correggere in
     silenzio: chi legge questo file deve saperlo prima di promettere altro.

     Cosa si salva: le tre porte, il tema, la pietra, la parola citata, la
     collezione d'ingresso e la data. Sono gli stessi campi del link condiviso,
     cioe' quanto basta a ricostruire la lettura identica: non c'e' niente di
     personale, e il testo scritto nel campo non esce di qui, come prima. */
  var KEEP_KEY = 'bh_responso_v1';
  function loadKept() {
    var raw = null;
    try { raw = window.localStorage.getItem(KEEP_KEY); } catch (e) { return null; }
    if (!raw) return null;
    var o;
    try { o = JSON.parse(raw); } catch (e) { return null; }
    if (!o || typeof o !== 'object') return null;
    var r = sanitizeReading(o.v, o.t, o.s, o.w);
    if (!r) return null;
    r.c = String(o.c || '');
    return r;
  }

  var LINK = null;
  var KEPT = false;
  (function () {
    var p = null;
    try { p = new URLSearchParams(location.search); } catch (e) {}
    if (p && p.get('v')) {
      /* LA LETTURA DI QUALCUN ALTRO VINCE SEMPRE, anche su chi il rito lo ha
         gia' fatto: un link condiviso non e' il tuo responso, e' il suo. */
      LINK = sanitizeReading(p.get('v'), p.get('t'), p.get('s'), p.get('w'));
      if (LINK) return;
    }
    var mine = loadKept();
    if (!mine) return;
    LINK = mine;
    KEPT = true;
    /* DUE COSE DIVERSE VIVEVANO NELLA STESSA VARIABILE, e una prometteva il falso.
       - SEED.handle e' DOVE TORNI. Li' l'URL deve vincere: se apri il tuo responso
         dalla fascia sulla pagina degli orecchini, la via d'uscita deve riportarti
         agli orecchini. Questa parte era gia' giusta.
       - SEED.cat e SEED.collection sono LA CELLA DA CUI E' STATA TRATTA LA LETTURA.
         Li' deve vincere SEMPRE il record salvato, perche' quella lettura e' stata
         fatta da li' e da nessun altro posto.
       Prima vinceva l'URL su tutte e tre, e il risultato era che riaprendo il
       proprio responso da una collezione diversa uscivano TRE PEZZI DIVERSI, sotto
       una riga che promette che quello che hai scelto resta. Misurato sul catalogo
       vivo: 56 confronti su 56, a parita' di porte e di pietra, davano un trio
       completamente diverso fra ingresso da /rings e ingresso da /earrings.
       Un responso che cambia i pezzi non e' rimasto: e' stato rifatto di nascosto.

       L'azzeramento prima di riapplicare non e' pedanteria: applySeed scrive cat e
       collection solo quando le riconosce, quindi tornando da /collections/earrings
       su un responso tratto da /collections/materia (che una forma non ce l'ha)
       la forma "orecchini" dell'URL sarebbe sopravvissuta alla riscrittura. */
    if (mine.c) {
      SEED.cat = 'any';
      SEED.collection = 'any';
      applySeed(mine.c, !SEED.handle);
    }
  })();

  /* ---------- il motore ---------- */
  var E = null;
  function engine(cb) {
    if (E) { cb(E); return; }
    var tries = 0;
    (function poll() {
      if (window.BHRiteEngine) { E = window.BHRiteEngine; cb(E); return; }
      if (++tries > 60) { cb(null); return; }
      setTimeout(poll, 50);
    })();
  }

  /* ---------- utilita' DOM ---------- */
  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* la via d'uscita, appena si sa dove porta */
  qa('[data-bhv-exit]').forEach(function (a) { a.setAttribute('href', exitHref()); });
  qa('[data-bhv-leave]').forEach(function (a) {
    a.setAttribute('href', exitHref());
    a.textContent = exitLabel();
  });
  /* ESC chiude, come qualunque cosa che occupa tutto lo schermo. Non chiede
     conferma: non c'e' niente da salvare, e il testo scritto non esce di qui. */
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape' && ev.key !== 'Esc') return;
    /* mentre si scrive, ESC e' del campo: svuotare per sbaglio la propria riga
       e ritrovarsi fuori dalla pagina sarebbe due danni in un tasto */
    var t = ev.target;
    if (t && (t.tagName === 'TEXTAREA' || t.tagName === 'INPUT')) { t.blur(); return; }
    leave();
  });

  /* ============================================================
     LE SCHERMATE
     Il palco e' fisso e non si scorre: a cambiare e' il contenuto, come nel
     Rito. Ogni schermata esce (300ms), poi la successiva entra (550ms). Sotto
     prefers-reduced-motion si sostituiscono e basta.
     ============================================================ */
  var screens = {};
  qa('[data-bhv-screen]').forEach(function (s) { screens[s.getAttribute('data-bhv-screen')] = s; });
  var current = screens.open;
  var swapping = false;

  function focusHead(scr) {
    var t = scr.querySelector('.bhv__q, .bhv__line, .bhv__kicker');
    if (!t) t = scr;
    try {
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
      /* preventScroll: dentro un palco fisso il browser altrimenti sposta il
         contenitore per "portare in vista" un titolo che e' gia' in vista */
      t.focus({ preventScroll: true });
    } catch (e) {}
  }

  function go(name) {
    var next = screens[name];
    if (!next || next === current || swapping) return;
    var prev = current;
    current = next;

    var swap = function () {
      prev.setAttribute('hidden', '');
      prev.classList.remove('is-out', 'is-in');
      next.removeAttribute('hidden');
      /* NON e' uno scorrimento: e' il contatore di scorrimento di una
         schermata che sta per entrare, riportato all'inizio. Non muove mai la
         pagina (il palco e' fixed) e non porta mai nessuno verso il basso;
         serve solo perche' tornando indietro su una porta gia' scorsa la si
         ritrovi dal titolo e non da meta'. */
      next.scrollTop = 0;
      if (!REDUCED) {
        /* reflow obbligatorio: senza, l'animazione con fill both non riparte
           e la schermata resta a opacita' zero, cioe' nera e vuota */
        void next.offsetWidth;
        next.classList.add('is-in');
      }
      swapping = false;
      focusHead(next);
      if (name === 'deck') prepareDeck();
      if (name === 'reading') startReading();
      if (name === 'pieces') startPieces();
    };

    if (REDUCED) { swap(); return; }
    swapping = true;
    prev.classList.add('is-out');
    setTimeout(swap, 300);
  }

  qa('[data-bhv-go]').forEach(function (btn) {
    btn.addEventListener('click', function () { go(btn.getAttribute('data-bhv-go')); });
  });

  /* ---------- schermata 0: la rottura ----------
     owner 29-08-2026: qui girava il film del cuore che si spezza. Bocciato: la
     schermata si apre sul testo e basta. Restano pero' le due cose che il blocco
     del film faceva quasi per caso e che servono ancora.
     1) is-settled, che scopre la riga e la mappa: senza, il velo non si alza mai
        e la schermata resta muta.
     2) il failsafe sul CTA. Non dipende piu' da un file remoto, ma resta perche'
        un bottone invisibile e' un vicolo cieco, e costa una riga. */
  (function opening() {
    var scr = screens.open;
    if (!scr || LINK) return;

    /* un battito, non un'attesa: senza, il browser applica lo stato finale nello
       stesso fotogramma e la dissolvenza del velo non si vede proprio. */
    if (REDUCED) { scr.classList.add('is-settled'); }
    else { setTimeout(function () { scr.classList.add('is-settled'); }, 260); }

    setTimeout(function () {
      var ct = q('[data-bhv-open-cta]', scr);
      if (ct) ct.style.setProperty('opacity', '1', 'important');
    }, 1400);
  })();

  /* Una tavola che non carica lascia il testo alternativo su fondo nero, che
     e' peggio del fondo dipinto in CSS: se l'immagine fallisce si toglie e
     resta .bhv-door__void, che sta gia' sotto. */
  qa('.bhv-door__img').forEach(function (im) {
    im.addEventListener('error', function () { im.style.display = 'none'; });
  });

  /* ---------- le tre porte ---------- */
  var warmed = false;
  qa('[data-bhv-door]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var gate = parseInt(btn.getAttribute('data-gate'), 10);
      var val = btn.getAttribute('data-value');
      if (!VALUES[gate] || !(val in VALUES[gate])) return;

      S[gate] = val;
      markGate(gate);

      /* il catalogo si scalda alla prima scelta: quando serve e' gia' li' */
      if (!warmed) { warmed = true; engine(function (e) { if (e) e.catalog(); }); }

      go(gate < 3 ? ('gate' + (gate + 1)) : 'say');
    });
  });

  function markGate(gate) {
    qa('[data-bhv-door][data-gate="' + gate + '"]').forEach(function (b) {
      var on = b.getAttribute('data-value') === S[gate];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-chosen', on);
      b.classList.toggle('is-passed', !on);
    });
  }

  /* ---------- la riga scritta: UN BOTTONE SOLO (owner 02-09-2026) ----------
     Prima erano due, [data-bhv-read] e [data-bhv-skip], e a campo vuoto
     facevano la stessa identica cosa (S.text = '' e go('deck')): due bottoni
     per un'azione sola, e uno dei due si chiamava "salta" quando non c'era
     niente da saltare. Ne resta uno, e a cambiare e' il nome: a campo pieno
     dice LEGGIMI, a campo vuoto LEGGI LE PORTE, che non e' un ripiego ma un
     secondo oggetto da leggere, perche' le porte sono gia' state scelte.
     Non si disabilita mai: la riga e' facoltativa e lo e' sempre stata.
     La chiave veglia.say_skip resta nei quindici locale file, inutilizzata. */
  var field = q('[data-bhv-field]');
  var readBtn = q('[data-bhv-read]');
  function syncSayLabel() {
    if (!readBtn) return;
    var full = !!(field && String(field.value || '').trim());
    var lab = full ? (C.sayFull || 'READ ME') : (C.sayEmpty || 'READ THE DOORS');
    if (readBtn.textContent !== lab) readBtn.textContent = lab;
  }
  if (field) {
    field.addEventListener('input', syncSayLabel);
    /* il campo puo' arrivare gia' pieno: il browser ripristina il testo
       tornando indietro, e l'etichetta resa da Liquid e' quella del vuoto */
    syncSayLabel();
  }
  if (readBtn) {
    readBtn.addEventListener('click', function () {
      S.text = field ? String(field.value || '').slice(0, 240) : '';
      go('deck');
    });
  }

  /* ---------- dalle porte all'oggetto risposte del motore ---------- */
  function buildAnswers(eng) {
    var d1 = S[1] || 'kept', d2 = S[2] || 'bond', d3 = S[3] || 'remember';
    var cluster = CLUSTER[d3] || CLUSTER.remember;
    var read = (S.text && eng.readThought) ? eng.readThought(S.text) : null;

    var theme;
    if (read && read.theme && cluster.indexOf(read.theme) > -1) {
      theme = read.theme;
    } else {
      var table = THEME_BY_DOORS[d3] || THEME_BY_DOORS.remember;
      theme = table[d1 + '_' + d2] || cluster[0];
    }

    /* QUI NON SI DECIDE PIU' LA PIETRA (owner 02-09-2026). Fino a ieri c'era
       `if (d2 === 'fracture') stone = 'blank'`: la porta II mandava SEMPRE a
       NIHIL, deterministica, e meta' delle persone vedeva sempre la stessa
       carta con le altre due li' per finta. La pietra adesso la decide la
       carta che si gira (vedi drawCard), e questo oggetto esce con
       stone: 'any', che e' il valore che il motore usa per "nessun vincolo":
       nessuno lo legge prima della pescata, ma se qualcuno lo leggesse per
       sbaglio conterebbe tutta la cella invece di una pietra a caso.
       La porta II non e' diventata finta: decide il tema insieme alle altre
       due (THEME_BY_DOORS, otto combinazioni) e resta nel token del link
       condiviso. Anche `read.stone`, che readThought sa restituire, non si usa
       piu' per lo stesso motivo: nessuna scorciatoia deve poter scavalcare la
       carta. Di readThought resta il tema, che affina dentro il grappolo, e la
       parola da citare. */
    return {
      a: {
        collection: SEED.collection,
        theme: theme,
        /* il metallo e' deciso: solo argento (owner 29-08-2026). Il mazzo che
           passiamo al motore e' gia' filtrato, questo lo dice anche a lui. */
        mat: 'silver',
        stone: 'any',
        cat: SEED.cat,
        tier: 0,
        vis: VALUES[1][d1]
      },
      word: worthQuoting(read && read.word)
    };
  }

  /* La cella puo' essere VUOTA, e allora il rito non risponde affatto.
     Caso reale trovato al banco il 28-08-2026: si entra da /collections/necklaces,
     la porta II dice "quello che l'ha tenuta insieme" (quindi una pietra), ma la
     casa le collane e i bracciali li fa solo senza pietra. `pickRelics` in quel
     caso esce subito con top:null e la persona vede un errore invece di una lettura.
     Si allenta nell'ordine che il motore stesso dichiara nei suoi commenti:
     prima cade la casa, poi la forma, e LA PIETRA NON SI ALLENTA MAI, perche' e'
     l'unica cosa che il rito ha davvero letto nella persona.
     Dal 29-08-2026 il conteggio gira sul mazzo GIA' filtrato a argento: contare
     su un catalogo piu' largo di quello da cui si pesca vorrebbe dire dichiarare
     aperta una cella che poi e' vuota. */
  function openCell(eng, P, a) {
    if (!eng.countCell) return a;
    if (eng.countCell(P, a.collection, a.stone, a.cat) > 0) return a;
    if (a.collection !== 'any' && eng.countCell(P, 'any', a.stone, a.cat) > 0) { a.collection = 'any'; return a; }
    if (a.cat !== 'any' && eng.countCell(P, a.collection, a.stone, 'any') > 0) { a.cat = 'any'; return a; }
    a.collection = 'any';
    a.cat = 'any';
    return a;
  }

  /* ============================================================
     IL MAZZO — quello che il Responso decide da solo (29-08-2026)

     Il motore sta in bh-rite.js, e' condiviso col Rito e NON si tocca: ma il
     mazzo da cui pescare lo sceglie chi pesca. Tre regole, tutte misurate
     sull'audit del catalogo vivo del 29-08.

     1. SOLO ARGENTO (richiesta owner). L'oro si riconosce in tre modi che sul
        catalogo di oggi coincidono tutti su 88 pezzi: il tag `golden`, il
        titolo che comincia per GOLDEN, il suffisso AUREUM. Si controllano
        tutti e tre lo stesso: il giorno che uno dei tre scivola, gli altri
        due reggono. Non e' un capriccio: `pickRelics` in tier 0 aggiunge fino
        a +13,80 punti per il prezzo, la mediana dell'oro e' 3.390 EUR contro
        200 dell'argento, e vinto il primo posto il motore blocca il metallo
        sul pezzo di testa, quindi il trio diventava tutto oro. Trentasei pezzi
        su cento erano in oro, due terzi su ciondoli e orecchini.

     1-bis. SOLO LE TRE FORME DEL CORE (owner 02-09-2026): "togli le collane
        perche' non sono quello che vendiamo come core, il quiz consigliera'
        anelli, pendenti, orecchini". `cross` sono i pendenti; `neck` (collane)
        e `wrist` (bracciali) escono dal mazzo. Anche questo filtro sta QUI e
        non in bh-rite.js: quel motore e' condiviso col Rito, che le collane le
        propone ancora.

     2. IL PEZZO DI TESTA E' IN TEMA, SEMPRE CHE ESISTA. Il motore non filtra
        mai per tema: da' +36 al primo tema, +20 al secondo, 0 al resto. Quando
        la cella non contiene pezzi in tema esce comunque qualcosa, e nessuno
        se ne accorge: 33 letture su 72 avevano almeno un pezzo fuori tema.
        Qui il TOP si pesca da un mazzo gia' ristretto al tema; i due compagni
        no, perche' la cella che il rito chiede davvero (tema + la sua pietra,
        in argento) vale da uno a dodici pezzi e pretendere tre in tema
        vorrebbe dire non rispondere.

     3. UNA FAMIGLIA SENZA RIGA IN FAMILY_META NON PUO' ESSERE IL PEZZO DI
        TESTA. `DEFAULT_META` regala a chi non e' censito i temi peso/inizio.
        `peso` la Veglia non lo chiede mai, ma `inizio` lo chiede spessissimo:
        quei pezzi risultavano "in tema" per un buco nella tabella, non per una
        decisione. Restano ottimi compagni, non parlano a nome del responso.
        Tolto l'oro restano tredici famiglie cosi': CICATRIX, CLAVUS, COR,
        CUNEUS, FAVUS, HIATUS, LACUNA, LORICA, PUMEX, RIMA, SINDON, TABULA,
        TEXTUM. Censirle in bh-rite.js e' il lavoro giusto, e va fatto la',
        non qui.
     ============================================================ */
  var CORE_CAT = { ring: 1, cross: 1, ear: 1 };
  function isCore(p) { return !!(p && CORE_CAT[p.cat] === 1); }
  function isGold(p) {
    if (!p) return false;
    if (p.mat === 'gold') return true;
    var n = String(p.name || '').toUpperCase();
    return n.indexOf('AUREUM') > -1 || n.indexOf('GOLDEN ') === 0;
  }
  function hasOwnMeta(p) {
    var M = (E && E.FAMILY_META) || null;
    if (!M) return true; /* senza la tabella non si esclude nessuno */
    return Object.prototype.hasOwnProperty.call(M, p.family);
  }
  function inTheme(p) {
    if (!S.a || !p || !p.themes) return false;
    if (!hasOwnMeta(p)) return false;
    return p.themes.indexOf(S.a.theme) > -1;
  }

  /* ============================================================
     IL MAZZO (DOM) e la pescata
     ============================================================ */
  var deck = q('[data-bhv-deck]');
  var deckHead = q('[data-bhv-deck-head]');
  var deckErr = q('[data-bhv-deck-err]');
  var after = q('[data-bhv-after]');
  var readErr = q('[data-bhv-read-err]');
  var readLeave = q('[data-bhv-read-leave]');
  var readCue = q('[data-bhv-cue]');
  var goPieces = q('[data-bhv-go-pieces]');
  var keptBox = q('[data-bhv-kept]');
  var cards = qa('[data-bhv-card]');

  /* ---------- LE SETTE CARTE, MESCOLATE ----------
     Una carta per pietra, e la corrispondenza posizione -> pietra vive SOLO
     qui dentro, in una variabile chiusa nella IIFE: non e' un attributo, non
     e' una classe, non e' una proprieta' appesa all'elemento. Nel sorgente
     servito le sette carte sono sette bottoni identici, e restano identici
     anche a pagina aperta finche' una non viene girata.
     Si mescola anche l'ORDINE DEI NODI, non solo l'assegnazione: oggi i sette
     bottoni sono indistinguibili e spostarli non cambia niente, ma il giorno
     che qualcuno aggiungesse una regola :nth-child o un ritardo per posizione,
     una carta sempre nello stesso posto tornerebbe a essere un indizio. */
  function shuffled(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }
  var stonesInDeck = [];
  (function dealDeck() {
    if (!deck || !cards.length) return;
    shuffled(cards).forEach(function (c) { deck.appendChild(c); });
    cards = qa('[data-bhv-card]');            /* l'array torna a seguire il DOM */
    stonesInDeck = shuffled(STONE_KEYS).slice(0, cards.length);
  })();
  function stoneOfCard(card) {
    var i = cards.indexOf(card);
    return (i > -1) ? (stonesInDeck[i] || null) : null;
  }

  /* le carte restano spente finche' il motore non ha risposto: un mazzo che si
     gira su niente sarebbe un errore mascherato da attesa */
  function lockCards(locked) {
    cards.forEach(function (c) {
      if (locked) { c.setAttribute('aria-disabled', 'true'); c.disabled = true; }
      else if (!S.drawn) { c.removeAttribute('aria-disabled'); c.disabled = false; }
    });
  }
  lockCards(true);

  /* Le carte non hanno testo dentro (sono due facce dipinte): senza questa
     riga sarebbero sette bottoni senza nome accessibile. Il numero serve a
     distinguerle a voce, non a suggerire cosa contengono: sono identiche, e
     dopo il mescolamento il numero non corrisponde a nessuna pietra fissa. */
  cards.forEach(function (c, i) {
    c.setAttribute('aria-label', (C.turn || 'Turn card') + ' ' + (i + 1));
  });

  function prepareDeck() {
    if (S.drawn) return;                /* gia' pescata: non si rimescola */
    S.ready = false;
    lockCards(true);
    if (deck) deck.removeAttribute('hidden');
    if (deckHead) deckHead.removeAttribute('hidden');
    if (deckErr) deckErr.setAttribute('hidden', '');

    /* i pezzi NON si caricano qui: dipendono dalla pietra, e la pietra non
       esiste ancora. Il catalogo pero' e' gia' in volo dalla prima porta
       (vedi warmed), quindi quando la carta si gira di solito e' gia' li'. */
    engine(function (eng) {
      if (!eng || !eng.pickRelics) { fail(); return; }
      var built = buildAnswers(eng);
      S.a = built.a;
      S.word = built.word;
      S.ready = true;
      lockCards(false);
    });
  }

  /* ---------- la lettura che arriva gia' fatta ----------
     Un link condiviso, oppure il proprio responso rimasto. In tutti e due i
     casi la pescata e' gia' avvenuta: il mazzo non si mostra, la pietra e'
     quella del parametro (o quella salvata) e si atterra sulla lettura. */
  function openReadingFrom(link) {
    engine(function (eng) {
      if (!eng || !eng.pickRelics) { go('deck'); return; }
      var built = buildAnswers(eng);
      S.a = built.a;
      S.word = link.w || null;
      if (link.t) S.a.theme = link.t;
      S.a.stone = link.s || eng.THEME_STONE[S.a.theme] || 'garnet';
      S.ready = true;
      S.drawn = true;                   /* non c'e' nessuna carta da girare */
      loadPicks(eng);
      fillReading(stoneCopy());
      if (KEPT && keptBox) keptBox.removeAttribute('hidden');
      go('reading');
    });
  }

  /* aggiunge un pezzo al trio: mai due volte lo stesso, e alla prima passata
     mai due volte lo stesso disegno */
  function addPick(list, p, freshFamily) {
    if (!p || list.length >= 3) return;
    for (var i = 0; i < list.length; i++) if (list[i].id === p.id) return;
    if (freshFamily) {
      for (var j = 0; j < list.length; j++) if (list[j].family === p.family) return;
    }
    list.push(p);
  }
  function addMany(list, arr, freshFamily) {
    if (!arr) return;
    for (var i = 0; i < arr.length && list.length < 3; i++) addPick(list, arr[i], freshFamily);
  }
  function ids(list) { return list.map(function (p) { return p.id; }); }

  function loadPicks(eng) {
    eng.catalog().then(function (P0) {
      if (!P0 || !P0.length) { noPieces(); return; }

      /* 1. solo argento, e solo le tre forme del core */
      var P = P0.filter(function (p) { return !isGold(p) && isCore(p); });
      /* salvagente a due gradini, e su nessuno dei due si e' mai arrivati con
         il catalogo di oggi: prima cade l'argento (meglio una lettura con
         l'oro che una pagina vuota), poi cade anche la forma. */
      if (P.length < 3) P = P0.filter(isCore);
      if (P.length < 3) P = P0;

      openCell(eng, P, S.a);

      /* porta I: il mazzo si stringe su cio' che si porta in vista o addosso;
         se la cella diventa troppo magra si riapre tutto, meglio una lettura
         piena che una coerenza formale con un pezzo solo */
      var pool = P.filter(function (p) { return p.vis === S.a.vis || p.vis === 'both'; });
      if (pool.length < 12) pool = P;

      /* 2. e 3. il pezzo di testa esce da un mazzo in tema e censito.
         LA SCALA, in ordine di quanto costa in dottrina. La PIETRA e la FORMA
         non si allentano mai: sono l'unica cosa che il rito ha letto nella
         persona e l'unica che la persona ha dichiarato entrando. Cade la casa,
         poi cade il tema, e solo alla fine cade il fatto di sapere cosa dice
         quella famiglia. Misurato: 77 letture su 100 hanno il pezzo di testa in
         tema (erano 39), 96 su 100 ce l'hanno censito. Le altre non sono un
         difetto: sono celle in cui quel pezzo, in argento, non esiste. */
      var themed = pool.filter(inTheme);
      var censused = pool.filter(hasOwnMeta);
      var picks = [];

      var r = themed.length ? eng.pickRelics(themed, S.a, []) : null;
      if ((!r || !r.top) && S.a.collection !== 'any') {
        /* la casa cade prima del tema: meglio un pezzo in tema di un'altra
           collezione che un pezzo della casa giusta che parla d'altro */
        var wide = {};
        for (var kk in S.a) wide[kk] = S.a[kk];
        wide.collection = 'any';
        var t2 = P.filter(function (p) { return (p.vis === S.a.vis || p.vis === 'both') && inTheme(p); });
        if (t2.length) r = eng.pickRelics(t2, wide, []);
      }
      if ((!r || !r.top) && censused.length) r = eng.pickRelics(censused, S.a, []);
      if (!r || !r.top) r = eng.pickRelics(pool, S.a, []);
      if (!r || !r.top) r = eng.pickRelics(P, S.a, []);
      if (!r || !r.top) { noPieces(); return; }

      addPick(picks, r.top, false);
      addMany(picks, r.alts, true);

      /* i compagni: prima dallo stesso mazzo del tema, poi dal mazzo della
         porta I, poi da tutto l'argento. La pietra non si allenta mai, e non
         si allenta qui: e' pickRelics a tenerla, a ogni chiamata. */
      var wider = [themed, pool, P];
      for (var w = 0; w < wider.length && picks.length < 3; w++) {
        if (!wider[w] || !wider[w].length) continue;
        var rr = eng.pickRelics(wider[w], S.a, ids(picks));
        if (!rr || !rr.top) continue;
        addMany(picks, [rr.top].concat(rr.alts || []), true);
      }
      /* ultimo giro senza il vincolo della famiglia: tre pezzi si devono */
      for (var w2 = 0; w2 < wider.length && picks.length < 3; w2++) {
        if (!wider[w2] || !wider[w2].length) continue;
        var r2 = eng.pickRelics(wider[w2], S.a, ids(picks));
        if (!r2 || !r2.top) continue;
        addMany(picks, [r2.top].concat(r2.alts || []), false);
      }

      S.picks = picks.slice(0, 3);
      picksSettled = true;
      /* se la schermata dei pezzi e' gia' aperta (motore lento), si riempie
         adesso invece di non riempirsi mai */
      if (piecesStarted) { fillRelics(); showPiece(0); }
      if (readingDone) closeReading();
    }).catch(noPieces);
  }

  function stoneCopy() {
    var stones = (E && E.COPY && E.COPY.stones) || [];
    for (var i = 0; i < stones.length; i++) if (stones[i].k === S.a.stone) return stones[i];
    return null;
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      if (S.drawn || !S.ready) return;
      drawCard(card);
    });
  });

  /* LA CARTA DECIDE LA PIETRA (owner 02-09-2026). Non c'e' nessuna pietra
     precalcolata da mostrare: si legge quale delle sette e' finita sotto
     questa posizione, la si scrive nelle risposte, e SOLO ADESSO si chiede al
     motore i tre pezzi, che dalla pietra dipendono. openCell e il filtro
     argento continuano a valere, e valgono sulla pietra appena scelta. */
  function drawCard(card) {
    if (S.drawn || !S.a || !card) return;
    var stone = stoneOfCard(card);
    if (!stone) return;
    S.drawn = card;
    S.a.stone = stone;

    var st = stoneCopy();

    engine(function (eng) { if (eng && eng.pickRelics) loadPicks(eng); else noPieces(); });

    var img = q('[data-bhv-card-img]', card);
    if (img && st && st.art) { img.src = st.art; img.alt = st.name || ''; }
    card.classList.add('is-turned');
    card.setAttribute('aria-pressed', 'true');
    /* girata, la carta non e' piu' "gira la carta": e' la pietra */
    if (st && st.name) card.setAttribute('aria-label', st.name);

    /* da qui non si torna: le altre sei non sono piu' toccabili */
    cards.forEach(function (c) {
      c.disabled = true;
      c.setAttribute('aria-disabled', 'true');
      if (c === card) return;
      c.classList.add('is-gone');
      /* da qui in poi sono sei dorsi e basta, e non si rivelano mai: fuori
         dall'albero di accessibilita', altrimenti uno screen reader continua a
         proporre sei carte da girare che non si girano piu'. Sono gia'
         disabled, quindi aria-hidden non nasconde niente raggiungibile con Tab. */
      c.setAttribute('aria-hidden', 'true');
    });
    if (deck) deck.classList.add('is-drawn');
    if (deckHead) deckHead.setAttribute('hidden', '');
    var back = q('[data-bhv-back-deck]');
    if (back) back.setAttribute('hidden', '');

    fillReading(st);

    /* owner 29-08-2026: "non voglio che quando scoprono la carta della pietra
       automaticamente devono scendere sotto, anche li deve apparire un'altra
       schermata". Quindi non si scorre: si aspetta che la carta abbia finito
       di girarsi, e poi il palco cambia schermata come fa fra una porta e
       l'altra. */
    setTimeout(function () { go('reading'); }, REDUCED ? 120 : 1250);
  }

  function fillReading(st) {
    var nameEl = q('[data-bhv-stone-name]');
    if (nameEl) nameEl.textContent = (st && st.name) || '';

    /* la carta girata viaggia con la lettura: senza, cambiando schermata si
       perderebbe di vista cosa e' uscito */
    var dImg = q('[data-bhv-drawn-img]');
    if (dImg) {
      if (st && st.art) { dImg.src = st.art; }
      else { var wrap = dImg.parentNode; if (wrap) wrap.setAttribute('hidden', ''); }
    }

    var txt = STONES[S.a.stone] || {};
    setText('[data-bhv-draw]', txt.draw);
    setText('[data-bhv-reading]', txt.reading);
    setText('[data-bhv-why]', txt.why);

    /* la parola che hai scritto davvero, mai una del nostro dizionario */
    var quote = q('[data-bhv-quote]');
    var wordEl = q('[data-bhv-word]');
    if (S.word && quote && wordEl) {
      wordEl.textContent = S.word;
      quote.removeAttribute('hidden');
    } else if (quote) {
      quote.setAttribute('hidden', '');
    }
  }

  function setText(sel, v) {
    var el = q(sel);
    if (!el) return;
    if (v) { el.textContent = v; el.removeAttribute('hidden'); }
    else { el.textContent = ''; el.setAttribute('hidden', ''); }
  }

  /* ---------- la lettura, in tre tempi ----------
     Non e' decorazione: e' la differenza fra una lettura e un pannello di
     testo. Chi non ha voglia di aspettare tocca lo schermo e arriva in fondo
     subito. */
  var timers = [];
  var readingStarted = false;
  var readingDone = false;
  /* il catalogo ha finito di rispondere, con o senza pezzi. Senza questo flag
     la lettura che arriva in fondo prima del catalogo mostrerebbe l'errore per
     un attimo e poi si correggerebbe da sola: un lampo rosso su una lettura
     riuscita. */
  var picksSettled = false;

  /* IL SEGNO DI SCORRIMENTO.
     Misurato al banco il 29-08-2026 a 390x780: la lettura non entra in uno
     schermo di telefono in nessuna delle quattordici varianti, e il CSS non
     puo' sapere se in questa lingua, su questo schermo, sotto ci sia ancora
     qualcosa. Quindi lo dice il JS, e solo quando e' vero: su un desktop alto
     il segno non compare mai. Al quarto tempo se ne va da solo (CSS), perche'
     da li' in poi il fondo lo tiene il passaggio ai tre pezzi. */
  function syncCue() {
    if (!readCue || !screens.reading) return;
    var s = screens.reading;
    var left = s.scrollHeight - s.clientHeight - s.scrollTop;
    readCue.hidden = !(left > 24);
  }
  if (screens.reading) {
    screens.reading.addEventListener('scroll', syncCue, { passive: true });
    window.addEventListener('resize', syncCue);
  }

  function startReading() {
    if (readingStarted || !after) return;
    readingStarted = true;
    var steps = ['is-r1', 'is-r2', 'is-r3', 'is-r4'];
    if (REDUCED) { steps.forEach(function (s) { after.classList.add(s); }); closeReading(); syncCue(); return; }
    var t = 260;
    steps.forEach(function (s, i) {
      timers.push(setTimeout(function () {
        after.classList.add(s);
        syncCue();
        if (i === steps.length - 1) closeReading();
      }, t));
      t += 1100;
    });
  }

  function revealAll() {
    if (!after || !readingStarted) return;
    if (after.classList.contains('is-r4')) return;
    timers.forEach(clearTimeout);
    timers = [];
    ['is-r1', 'is-r2', 'is-r3', 'is-r4'].forEach(function (s) { after.classList.add(s); });
    closeReading();
    syncCue();
  }
  if (screens.reading) {
    /* NON su pointerdown: la lettura scorre sempre (la piu' lunga sfora di
       ~200px su un telefono da 390x780), e pointerdown e' l'unico evento che
       non sa distinguere un tocco da uno scorrimento. Chi trascinava per
       cercare il passaggio ai tre pezzi si collassava i tre tempi da solo.
       Qui si misura lo spostamento: sotto i 10px e' un tocco, sopra e' uno
       scorrimento. pointercancel copre il caso in cui e' il browser stesso a
       prendersi il gesto per scorrere. */
    var tapX = 0, tapY = 0, tapping = false;
    screens.reading.addEventListener('pointerdown', function (ev) {
      tapping = true; tapX = ev.clientX; tapY = ev.clientY;
    });
    screens.reading.addEventListener('pointercancel', function () { tapping = false; });
    screens.reading.addEventListener('pointerup', function (ev) {
      if (!tapping) return;
      tapping = false;
      if (Math.abs(ev.clientX - tapX) > 10 || Math.abs(ev.clientY - tapY) > 10) return;
      revealAll();
    });
    screens.reading.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') revealAll();
    });
  }

  /* la lettura e' finita: si passa ai pezzi. Se il catalogo non ha risposto la
     lettura resta valida lo stesso, e al posto del passaggio compare la via
     d'uscita: meglio mezza pagina vera che una pagina di errore su una lettura
     riuscita. */
  var keptSaved = false;
  /* Il proprio responso resta, e resta QUI: nel browser, non su un server.
     Si salva a lettura finita e non prima, perche' una lettura interrotta a
     meta' non e' un responso. Non si salva mai la lettura di qualcun altro
     (LINK dall'URL) ne' la propria riaperta (KEPT): sarebbe riscrivere la
     stessa cosa con una data nuova. Se localStorage non c'e' o e' pieno, non
     succede niente: il rito si potra' rifare, ed e' il male minore. */
  function saveKept() {
    if (keptSaved || LINK || KEPT) return;
    if (!S.a || !S.a.stone || S.a.stone === 'any') return;
    keptSaved = true;
    try {
      window.localStorage.setItem(KEEP_KEY, JSON.stringify({
        v: doorsToken(),
        t: S.a.theme || '',
        s: S.a.stone || '',
        w: S.word || '',
        c: SEED.handle || '',
        at: new Date().toISOString().slice(0, 10)
      }));
    } catch (e) {}
  }

  function closeReading() {
    readingDone = true;
    saveKept();
    if (!picksSettled) {
      /* si aspetta in silenzio: loadPicks richiama questa funzione appena sa */
      if (goPieces) goPieces.hidden = true;
      if (readErr) readErr.hidden = true;
      if (readLeave) readLeave.hidden = true;
      return;
    }
    var ok = S.picks.length > 0;
    if (goPieces) goPieces.hidden = !ok;
    if (readErr) readErr.hidden = ok;
    if (readLeave) readLeave.hidden = ok;
  }
  if (goPieces) {
    goPieces.hidden = true;
    goPieces.addEventListener('click', function () { go('pieces'); });
  }

  /* ============================================================
     I TRE PEZZI, UNO ALLA VOLTA
     owner 29-08-2026: "quando escono i 3 pezzi devono essere raccontati uno ad
     uno, non che li mettono tutti e 3 insieme". Quindi: un pannello per volta,
     il successivo si chiede, e i tre numerali del Codex permettono di tornare
     su quelli gia' raccontati. Non sono una barra di avanzamento: quelli che
     non sono ancora stati raccontati restano spenti e non cliccabili, cosi'
     nessuno puo' saltare in fondo e nessuno vede un contatore.
     ============================================================ */
  var tabs = qa('[data-bhv-tab]');
  var relics = qa('[data-bhv-relic]');
  var nextBtn = q('[data-bhv-next]');
  var closeBox = q('[data-bhv-close]');
  var piecesStarted = false;

  function startPieces() {
    if (piecesStarted) return;
    piecesStarted = true;
    fillRelics();
    showPiece(0);
  }

  /* ---------- LE TRE BATTUTE DEL PANNELLO (owner 02-09-2026) ----------
     "I pezzi devono essere raccontati, non che prendono e gli mostri la
     descrizione, e devono essere spiegati." Il pannello aveva gia' tutto il
     racconto, ma arrivava in blocco, prezzo compreso: e un prezzo che arriva
     prima del racconto trasforma una lettura in un listino.
     Adesso arriva a tempi, come la lettura della pietra che i suoi tre tempi
     ce li ha gia': chi e' il pezzo, perche' e' capitato in quella posizione,
     e infine il dato con la porta. Nessuna copy nuova: e' la stessa,
     riordinata. Chi non ha voglia di aspettare tocca il pannello e arriva in
     fondo subito, esattamente come nella lettura.
     Un pannello gia' raccontato si riapre intero: tornando su di lui col
     numerale del Codex non ricomincia la recita. */
  var BEAT = ['is-b1', 'is-b2', 'is-b3'];
  var beatTimers = [];
  function tellAll(row) {
    if (!row) return;
    beatTimers.forEach(clearTimeout);
    beatTimers = [];
    BEAT.forEach(function (cl) { row.classList.add(cl); });
    row.setAttribute('data-bhv-told', '1');
  }
  function tellPiece(row) {
    if (!row) return;
    beatTimers.forEach(clearTimeout);
    beatTimers = [];
    if (REDUCED || row.getAttribute('data-bhv-told') === '1') { tellAll(row); return; }
    BEAT.forEach(function (cl) { row.classList.remove(cl); });
    BEAT.forEach(function (cl, i) {
      beatTimers.push(setTimeout(function () {
        row.classList.add(cl);
        if (i === BEAT.length - 1) row.setAttribute('data-bhv-told', '1');
      }, 140 + i * 920));
    });
  }
  if (screens.pieces) {
    /* stessa misura del tocco della lettura: sotto i 10px e' un tocco, sopra
       e' uno scorrimento, e chi trascina per leggere non si collassa il
       racconto da solo. Un tocco sul CTA lo lascia passare: e' un link. */
    var pTapX = 0, pTapY = 0, pTapping = false;
    screens.pieces.addEventListener('pointerdown', function (ev) {
      pTapping = true; pTapX = ev.clientX; pTapY = ev.clientY;
    });
    screens.pieces.addEventListener('pointercancel', function () { pTapping = false; });
    screens.pieces.addEventListener('pointerup', function (ev) {
      if (!pTapping) return;
      pTapping = false;
      if (Math.abs(ev.clientX - pTapX) > 10 || Math.abs(ev.clientY - pTapY) > 10) return;
      tellAll(relics[S.shown]);
    });
  }

  function showPiece(i) {
    if (!S.picks.length) return;
    var max = Math.min(S.picks.length, relics.length) - 1;
    if (i < 0) i = 0;
    if (i > max) i = max;
    S.shown = i;
    if (i > S.seen) S.seen = i;

    relics.forEach(function (row, k) {
      if (k === i) row.removeAttribute('hidden');
      else row.setAttribute('hidden', '');
    });
    tabs.forEach(function (t, k) {
      var reached = k <= S.seen && k <= max;
      t.disabled = !reached;
      t.setAttribute('aria-selected', k === i ? 'true' : 'false');
      t.setAttribute('tabindex', k === i ? '0' : '-1');
      t.classList.toggle('is-on', k === i);
      t.classList.toggle('is-seen', reached);
    });

    tellPiece(relics[i]);

    var last = S.seen >= max;
    if (nextBtn) nextBtn.hidden = S.shown >= max;
    if (closeBox) { if (last) closeBox.removeAttribute('hidden'); else closeBox.setAttribute('hidden', ''); }
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      showPiece(S.shown + 1);
      /* il pannello nuovo prende il fuoco: chi usa uno screen reader deve
         sentire il pezzo appena arrivato, non restare sul bottone */
      var row = relics[S.shown];
      if (row) { try { row.focus({ preventScroll: true }); } catch (e) {} }
    });
  }
  relics.forEach(function (row) {
    row.addEventListener('keydown', function (ev) {
      if (ev.target !== row) return;
      if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') { ev.preventDefault(); tellAll(row); }
    });
  });
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (t.disabled) return;
      showPiece(parseInt(t.getAttribute('data-bhv-tab'), 10) || 0);
    });
    t.addEventListener('keydown', function (ev) {
      var d = (ev.key === 'ArrowRight') ? 1 : (ev.key === 'ArrowLeft') ? -1 : 0;
      if (!d) return;
      ev.preventDefault();
      var n = S.shown + d;
      if (n < 0 || n > S.seen) return;
      showPiece(n);
      if (tabs[n]) { try { tabs[n].focus({ preventScroll: true }); } catch (e) {} }
    });
  });

  /* ---------- riempire i tre pannelli ---------- */
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function money(n) {
    var dec = (n % 1) !== 0;
    try {
      return new Intl.NumberFormat(C.locale || 'en', {
        style: 'currency', currency: C.currency || 'EUR',
        minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: dec ? 2 : 0, useGrouping: false /* owner 15-10-2026: prezzi senza separatore delle migliaia */
      }).format(n);
    } catch (e) { return String(Math.round(n)); }
  }

  function fillRelics() {
    if (!S.picks.length) return;
    S.picks.forEach(function (p, idx) {
      var row = relics[idx];
      if (!row || !p) return;
      /* il ritmo si accende QUI, prima che il pannello si veda: se la classe
         arrivasse dopo, il pannello lampeggerebbe intero e poi si accorcerebbe.
         Senza JavaScript questa classe non c'e' e il pannello resta intero. */
      row.classList.add('is-timed');
      var img = q('[data-bhv-relic-img]', row);
      if (img) { img.src = sized(p.img, 500); img.alt = p.name; }
      var nm = q('[data-bhv-relic-name]', row); if (nm) nm.textContent = p.name;

      /* LA LETTURA DI POSIZIONE.
         `idx` e' il posto nella stesa, non un numero d'ordine qualunque: il
         primo pannello e' QUELLO CHE PORTI, il secondo QUELLO CHE TACI, il
         terzo QUELLO CHE RESTA, ed e' cosi' che l'etichetta e' gia' scritta
         in Liquid. Il tema, invece, lo porta il pezzo. Se manca, o non e' fra
         i sette, la riga resta nascosta e il pannello e' esattamente quello
         di prima: nessun buco, nessun testo a caso. */
      var pos = q('[data-bhv-relic-pos]', row);
      if (pos) {
        var slot = POS_SLOT[idx];
        var theme0 = (p.themes && p.themes.length) ? p.themes[0] : '';
        var ptxt = (slot && theme0 && POS[theme0]) ? (POS[theme0][slot] || '') : '';
        pos.textContent = ptxt;
        pos.hidden = !ptxt;
      }

      /* LA STORIA DEL PEZZO (owner 29-08-2026, punto 5).
         Il sottotitolo del prodotto e' gia' tradotto in quindici lingue: se
         c'e', e' LUI la storia, e il `line`/`why` del motore non si mostrano.
         Non e' un taglio di contenuto, e' un taglio di lingua: quei due campi
         escono in inglese anche in giapponese, e affiancarli a una riga
         italiana faceva sembrare rotta la pagina. Quando il sottotitolo manca
         (un pezzo senza metafield, o oltre il tetto di 250 di paginate) si
         torna esattamente a come era prima. */
      var sub = SUBS[p.id];
      var ln = q('[data-bhv-relic-line]', row);
      var wh = q('[data-bhv-relic-why]', row);
      if (sub) {
        if (ln) { ln.textContent = sub; ln.hidden = false; }
        if (wh) { wh.textContent = ''; wh.hidden = true; }
      } else {
        var ltxt = deEnt(p.line || '');
        var wtxt = deEnt(p.why || '');
        if (ln) { ln.textContent = ltxt; ln.hidden = !ltxt; }
        if (wh) { wh.textContent = wtxt; wh.hidden = !wtxt; }
      }

      var pr = q('[data-bhv-relic-price]', row); if (pr) pr.textContent = money(p.price);
      var fr = q('[data-bhv-relic-from]', row);
      if (fr) { if (p.from) fr.removeAttribute('hidden'); else fr.setAttribute('hidden', ''); }
      var cta = q('[data-bhv-relic-cta]', row);
      if (cta && E) {
        try { cta.href = E.reclaimUrl(S.a, p); } catch (e) { cta.href = E.root() + 'products/' + p.id; }
        cta.setAttribute('aria-label', (C.see || 'See the piece') + ': ' + p.name);
      }
    });
  }

  /* ---------- quando non si puo' leggere ---------- */
  function fail() {
    /* un mazzo che non si puo' girare non deve restare li' a invitare */
    if (deck) deck.setAttribute('hidden', '');
    if (deckHead) deckHead.setAttribute('hidden', '');
    if (deckErr) deckErr.removeAttribute('hidden');
  }
  /* la pietra c'e', il catalogo no: la lettura resta, i pezzi no. */
  function noPieces() {
    S.picks = [];
    picksSettled = true;
    if (readingDone) closeReading();
  }

  /* ---------- portarla via ---------- */
  function doorsToken() {
    return (LETTER[S[1]] || 'b') + (LETTER[S[2]] || 'b') + (LETTER[S[3]] || 'a');
  }
  function shareLink() {
    var v = doorsToken();
    var u = location.origin + location.pathname + '?v=' + v +
      '&t=' + encodeURIComponent((S.a && S.a.theme) || '') +
      '&s=' + encodeURIComponent((S.a && S.a.stone) || '');
    if (S.word) u += '&w=' + encodeURIComponent(S.word);
    /* la porta d'ingresso viaggia col link: senza, chi apre la lettura
       condivisa vedrebbe un trio scelto su un mazzo piu' largo del tuo */
    if (SEED.handle) u += '&c=' + encodeURIComponent(SEED.handle);
    return u;
  }

  var storyBtn = q('[data-bhv-story]');
  if (storyBtn) {
    storyBtn.addEventListener('click', function () {
      if (!E || !E.shareStory || !S.picks.length) return;
      /* il link dentro lo share e' QUESTA pagina, non /pages/rite: il token
         a cinque caratteri del Rito non sa portare ne' la porta I ne' la
         parola scritta, e chi apre il link vedrebbe un'altra lettura */
      try { E.shareStory(S.a, S.picks[0], storyBtn, shareLink()); } catch (e) {}
    });
  }
  var copyBtn = q('[data-bhv-copy]');
  if (copyBtn) {
    var copyLabel = copyBtn.textContent;
    copyBtn.addEventListener('click', function () {
      var url = shareLink();
      var ok = function () {
        copyBtn.textContent = C.copied || 'Copied';
        setTimeout(function () { copyBtn.textContent = copyLabel; }, 2400);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(ok).catch(function () { window.prompt(C.copy || '', url); });
      } else {
        try { window.prompt(C.copy || '', url); } catch (e) {}
      }
    });
  }

  /* owner 29-08-2026: "puo' essere fatto una sola volta, quindi togli il rifai
     veglia, ma semplicemente ti fa ritornare nella pagina precedente della
     collezione". Il bottone data-bhv-again e la sua logica sono spariti da
     qui e dalla sezione. La chiave veglia.v_again resta nei quindici locale
     file: inutilizzata, non da cancellare a cuor leggero. */

  /* ---------- e infine: la lettura che c'e' gia' ----------
     Due casi, e si comportano allo stesso modo perche' sono la stessa cosa:
     il link condiviso da qualcun altro, e il proprio responso rimasto nel
     browser. Le tre porte riempiono lo stato (cosi' pickRelics riceve lo
     stesso oggetto risposte di chi l'ha generata) e si atterra DIRITTI sulla
     lettura: il mazzo non si mostra, perche' quella carta e' gia' girata.
     Differenza unica: il proprio responso porta anche il blocco "rimasto",
     che dice che il rito si fa una volta. */
  if (LINK) {
    S[1] = UNLETTER[1][LINK.v.charAt(0)];
    S[2] = UNLETTER[2][LINK.v.charAt(1)];
    S[3] = UNLETTER[3][LINK.v.charAt(2)];
    markGate(1); markGate(2); markGate(3);
    openReadingFrom(LINK);
  }
})();
